<!--
 * @Author: 仙道
 * @Date: 2022-08-10 18:17:11
 * @LastEditTime: 2022-09-19 23:22:40
 * @email: hao.li08@weimob.com
 * @Description: 生产厂家详情
 * @FilePath: /iplus-iwt-fe/src/views/fusion/components/Manufacturers.vue
-->
<template>
  <page-layout :breadcrumb="false" :title="`${record.manuName||'-'}`">
    <div class="page-header-content" slot="headerContent">
      <div class="content"></div>
    </div>

    <div class="c-tabs">
      <a-card :bordered="false">
        <a-tabs v-if="!viewLoading">
          <a-tab-pane :key="item.key" :tab="item.tab" v-for="(item) in componentList">
            <component :is="item.views" :query="item.query" />
          </a-tab-pane>
        </a-tabs>
      </a-card>
    </div>
  </page-layout>
</template>
<script>
  import { mapState } from 'vuex'
  import PageLayout from '@/components/page/PageLayout'
  import { getAction } from '@/api/manage'

  export default {
    // 生产厂家详情
    name: 'FusionManufacturers',
    components: {
      PageLayout
    },
    props: {
      query: {
        type: Object,
        default: () => { }
      }

    },
    // 定义属性
    data () {
      return {
        mapKey: 'Manufacturers',
        record: {},
        componentList: [{
          view: 'DevListList',
          path: 'equipment/account/vue/DevListListForDetail',
          name: '设备台账'
        },
        {
          view: 'DefRegisterListForDetail',
          path: 'equipment/defect/vue/DefRegisterListForDetail',
          name: '缺陷记录'
        }
          , {
          view: 'IotAlertListForDetail',
          path: 'monitor/alert/IotAlertListForDetail',
          name: '告警记录'
        }
        ],
        viewLoading: true
      }
    },
    // 计算属性，会监听依赖属性值随之变化
    computed: {
      // ...mapGetters(['detailMap'])
      ...mapState({
        detailMap: state => state.user.detailMap
      }),

    },
    // 监控data中的数据变化
    watch: {},
    // 生命周期 - 创建完成（可以访问当前this实例）
    created () {

      this.initData()
    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted () {

    },
    // 方法集合
    methods: {
      async initData () {

        const { success, result } = await getAction('/device/commonManufacturer/queryById', { id: this.$route.params?.id ?? this.query?.id })
        if (success) {
          this.record = { ...result }
          this.Initialize()
        }
      },
      Initialize () {
        const manuId = this.$route.params?.id ?? this.query?.id
        const tabs = this.componentList.reduce((arr, cur) => {
          arr.push({
            query: {
              manuId
            },
            tab: cur.name,
            key: cur.view,
            views: (resolve) => require([`@/views/${cur.path}.vue`], resolve)
          })
          return arr
        }, [])

        this.componentList = tabs
        this.viewLoading = false

      }
    }
  }
</script>

<style lang='less' scoped>
  // @import './index.less';

  .detail-layout {
    margin-left: 44px;
  }
  .text {
    color: rgba(0, 0, 0, 0.45);
  }
  .c-tabs {
    background: #fff;
    &-panel {
      min-height: 400px;
      &-head {
        font-size: 16px;
        font-weight: 700;
      }
    }
  }
  .device-img {
    width: 100px !important;
    height: 100px !important;
    border-radius: 0% !important;
  }
  ::v-deep {
    .content {
      position: relative;
      margin-top: 0px;
    }
    .page-header {
      border-bottom: none;
    }
    .term {
      vertical-align: top;
    }
    .ant-descriptions-row {
      .ant-descriptions-item-label {
        vertical-align: inherit;
      }
      .ant-descriptions-item-content {
        vertical-align: inherit;
      }
    }
    .ant-upload.ant-upload-select-picture-card {
      height: 100px;
      width: 100px;
    }
    img {
      height: 40px;
      width: 40px;
    }
  }
</style>
